import React, { useMemo } from "react";
import type { GridColDef } from "@mui/x-data-grid";
import type { IncrementView } from "@services/drybulkCargoOperationsApi";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";
import { formatInstant } from "../utils/formatInstant";
import OperationDataGrid from "./OperationDataGrid";

const L = DRYBULK_CARGO_OPS_LANG_BASE;

const IncrementsTable: React.FC<{ increments: IncrementView[] }> = ({ increments }) => {
  const { t } = useTranslation();
  const columns = useMemo<GridColDef[]>(
    () => [
      { field: "incrementNo", headerName: t(`${L}.list.columns.id`), flex: 0.5, minWidth: 60 },
      {
        field: "quantity",
        headerName: t(`${L}.list.columns.quantity`),
        flex: 1,
        minWidth: 100,
        valueGetter: (_value, row) => row.quantity ?? "-",
      },
      {
        field: "ats",
        headerName: t(`${L}.sequences.grid.ats`),
        flex: 1.5,
        minWidth: 140,
        valueGetter: (_value, row) => formatInstant(row.ats),
      },
      {
        field: "atc",
        headerName: t(`${L}.sequences.grid.atc`),
        flex: 1.5,
        minWidth: 140,
        valueGetter: (_value, row) => formatInstant(row.atc),
      },
    ],
    [t],
  );
  const rows = useMemo(
    () => [...increments].sort((a, b) => a.incrementNo - b.incrementNo),
    [increments],
  );

  return (
    <OperationDataGrid
      title={t(`${L}.sequences.execution.section.increments`)}
      testId="sequence-details-increments"
      columns={columns}
      rows={rows}
      emptyMessage={t(`${L}.sequences.execution.section.no-increments`)}
    />
  );
};

export default IncrementsTable;
